export default "__VITE_ASSET__B8UV2Kss__"